import React,  { useEffect, useState, useRef } from 'react';
import { useSearchParams, useNavigate, Navigate } from 'react-router-dom';
import './App.scss';
import 'bootstrap/dist/css/bootstrap.min.css';
import Button from 'react-bootstrap/Button'
import { Route, Routes } from 'react-router-dom';
import RegisztracioOldal from './components/app/RegisztracioOldal';
import MegrendelesOldal from './components/app/MegrendelesOldal';
import Rendezvenyek from './components/app/Rendezvenyek';
import RendConf from './components/app/RendConf';
import AdminOldal from './components/admin/AdminOldal';
import { osszesVazlatTorlese, regisztracioCel } from './vazlat';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { library } from '@fortawesome/fontawesome-svg-core'
import { fas } from '@fortawesome/free-solid-svg-icons'
library.add(fas)

// A belépési token (az e-mailben kapott linkből vagy a Google-belépésből) a lap bezárásáig megmarad,
// az újratöltést túléli.
const TOKEN_STORAGE_KEY = 'rendezveny_token';

function readStoredToken() {
  try {
    return window.sessionStorage.getItem(TOKEN_STORAGE_KEY);
  } catch (e) {
    return null;
  }
}

function writeStoredToken(token) {
  try {
    if (token) {
      window.sessionStorage.setItem(TOKEN_STORAGE_KEY, token);
    } else {
      window.sessionStorage.removeItem(TOKEN_STORAGE_KEY);
    }
  } catch (e) {
    // tiltott tárhely esetén a token csak a memóriában él
  }
}

function App(props) {
  const tokenRef = useRef(readStoredToken());
  // Az első betöltéskor kapott URL-paraméterek (a "/" átirányítás és az útvonalváltás után már nem érhetők el):
  //   ?t=<token>               belépő link (e-mailből)
  //   ?t=<token>&r=<rendID>    belépő link egy rendezvényhez (e-mailből, a "Regisztrálok" után)
  //   ?t=<token>&mgrID=<id>    megrendelés-link (e-mailből, fizetés után)
  //   ?mgrID=<id>              megrendelés megnyitása
  const [searchParams] = useSearchParams();
  const kezdoParams = useRef({
    t: searchParams.get("t"),
    mgrID: searchParams.get("mgrID"),
    r: searchParams.get("r")
  });
  const bootstrapMegtortent = useRef(false);

  const [API_URL, setAPI_URL] = useState(undefined);
  const [konfigKesz, setKonfigKesz] = useState(false);
  const [apiErrorMessage, setApiErrorMessage] = useState(undefined);
  const [commInProgress, setCommInProgress] = useState(false);
  // A belépett felhasználó: undefined = még töltődik (a belépés visszaállítása folyamatban), null = vendég,
  // egyébként {Id, Email, Nev, admin, foadmin, vevo, szamlazasiAdatokTeljesek, megrendeltRendezvenyekByID}
  const [felhasznalo, setFelhasznalo] = useState(undefined);
  let navigate = useNavigate();

  function getCommInProgress(){
    return commInProgress;
  }

  function getConfigData() {
    fetch('/RendConfJs.json?' + new Date().getTime())
        .then(function(r) {
            return r.json()
        })
        .then(function(c) {
            RendConf.url_api = c.url_api;
            setAPI_URL(c.url_api)
        });
  }

  useEffect(getConfigData, [])

  // Az oldal nyilvános beállításai (cím, kapcsolat, Google Client ID): egyszer, az API címének ismeretében.
  useEffect(() => {
    if (API_URL === undefined){
      return;
    }
    callAPI("General.getRendConf", {}, function(resp){
      RendConf.page_title = resp.data.page_title;
      RendConf.contact_email = resp.data.contact_email;
      RendConf.szabalyzatURL = resp.data.szabalyzatURL;
      RendConf.google_login_client_id = resp.data.google_login_client_id;
      RendConf.oldal_cim = resp.data.oldal_cim;
      RendConf.oldal_alcim = resp.data.oldal_alcim;
      RendConf.oldal_alcim_rovid = resp.data.oldal_alcim_rovid;
      setKonfigKesz(true);
    });
  }, [API_URL])

  // A belépés visszaállítása (egyszer): belépő link, vagy a lapon tárolt token. Amíg ez tart, a védett oldalak várakoznak.
  useEffect(() => {
    if (!konfigKesz || bootstrapMegtortent.current){
      return;
    }
    bootstrapMegtortent.current = true;
    const p = kezdoParams.current;

    if (p.t !== null) {
      //
      //     BELÉPŐ LINK: a token érvényességét a SZERVER ellenőrzi
      //
      setToken(p.t);
      callAPI("General.loginWithLink", {}, function(resp){
        const f = resp.data.felhasznalo;
        setFelhasznalo(f);
        // technikai átirányítás (replace): a tokent tartalmazó cím nem marad az előzményekben
        if (p.mgrID !== null) {
          navigate('/megrendeles/' + encodeURIComponent(p.mgrID), {replace: true});
        }else if (p.r !== null && /^[0-9]+$/.test(p.r)) {
          navigate(regisztracioCel(f, p.r), {replace: true});
        }else{
          navigate('/rendezvenyek', {replace: true});
        }
      }, function(){
        setToken(null);
        setFelhasznalo(null);
        navigate('/rendezvenyek', {replace: true});
      });
    }else if (tokenRef.current){
      callAPI("General.getFelhasznalo", {}, function(resp){
        setFelhasznalo(resp.data.felhasznalo);
        if (p.mgrID !== null) {
          navigate('/megrendeles/' + encodeURIComponent(p.mgrID), {replace: true});
        }
      }, function(){
        // lejárt vagy érvénytelen token: csendben vendéggé válunk
        kilepes();
        return false;
      });
    }else{
      setFelhasznalo(null);
      if (p.mgrID !== null) {
        // belépés nélkül nem nézhető meg: a védett oldal a belépő ablakot nyitja
        navigate('/megrendeles/' + encodeURIComponent(p.mgrID), {replace: true});
      }
    }
  }, [konfigKesz])

  function setToken(token){
    tokenRef.current = token || null;
    writeStoredToken(token);
  }

  function kilepes(){
    setToken(null);
    osszesVazlatTorlese();
    setFelhasznalo(null);
  }

  function onClick_kilepes(){
    kilepes();
    navigate('/rendezvenyek', {replace: true});
  }

  async function callAPI(method, data, successHandler, errorHandler){
    setCommInProgress(true);
    if (API_URL === undefined){
      console.log("API_URL not set. Method: " + method)
    }else{
      const answer = await callAPIAsync(method, data);
      setCommInProgress(false);
      const answerText = await answer.text(); // Parse it as text
      try {
        const answerJson = JSON.parse(answerText); // Try to parse it as JSON
        if (answerJson.status === 'success'){
          successHandler(answerJson);
        }else{
          if (answerJson.code === 'auth'){
            // lejárt vagy érvénytelen belépés
            kilepes();
          }
          if (answerJson.code === 'forbidden'){
            // nincs (már) joga: vissza a rendezvényekhez, a jogosultságok frissítésével
            navigate('/rendezvenyek', {replace: true});
            callAPIAsync("General.getFelhasznalo", {}).then(function(r){ return r.json(); }).then(function(j){
              if (j.status === 'success'){ setFelhasznalo(j.data.felhasznalo); }
            }).catch(function(){});
          }
          if (errorHandler !== undefined){
            if (errorHandler(answerJson) === false){
              return;   // a hívó kezelte, nincs felugró üzenet
            }
          }
          answerJson.userMsg = String(answerJson.userMsg || '').replace(/\*/ig, "\n");
          alert(answerJson.userMsg);
        }
      } catch(err) {
        alert("Kommunikációs hiba lépett fel. Kérjük, kezdje újra a jelentkezést, vagy vegye fel a kapcsolatot iskolánkkal.");
        console.log(answerText);
        setApiErrorMessage(answerText)
      }
    }
  }

  window.validateEmail = function(email) {
    var re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(email);
  }

  async function callAPIAsync(method, data) {
    if (data === undefined) {data = {}}
    var jsonstring = JSON.stringify({
        method: method,
        data: data,
        token: tokenRef.current
    });

    return fetch(API_URL, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: jsonstring
    })
  }

  // A felhasználó adatainak újratöltése a szerverről (pl. a megrendelései megváltozása után); a kész
  // függvény megkapja a friss felhasználót. Vendégnél nem csinál semmit.
  function frissitFelhasznalo(kesz){
    if (!tokenRef.current){
      return;
    }
    callAPI("General.getFelhasznalo", {}, function(resp){
      setFelhasznalo(resp.data.felhasznalo);
      if (kesz !== undefined){
        kesz(resp.data.felhasznalo);
      }
    });
  }

  // A felhasználó neve (megszólítás, tartalék név); a számlára a számlázási adatoknál megadott név kerül.
  function onSetNev(nev, onSuccess){
    callAPI("General.saveFelhasznaloNev", {nev: nev}, function(resp){
      setFelhasznalo(resp.data.felhasznalo);
      if (onSuccess !== undefined){
        onSuccess(resp.data.felhasznalo);
      }
    });
  }

  // A Google gomb a Google-tól kapott ID tokent adja át; a szerver ellenőrzi, és belépési tokent ad.
  function onGoogleCredential(credential, onSuccess){
    callAPI("General.googleLogin", {credential: credential}, function(resp){
      setToken(resp.data.token);
      setFelhasznalo(resp.data.felhasznalo);
      if (onSuccess !== undefined){
        onSuccess(resp.data.felhasznalo);
      }
    });
  }

  function onClick_errorMessage(){
    setApiErrorMessage(undefined);
  }

  // Védett oldal: amíg a belépés visszaállítása tart, várakozik; vendégnek a lista nyílik meg a belépő ablakkal
  // (belepes: {rendezvenyID?, cel?}: hová kell lépni a belépés után).
  function vedett(elem, belepes){
    if (felhasznalo === undefined){
      return <div className="betoltes">Töltés...</div>;
    }
    if (felhasznalo === null){
      return <Navigate to="/rendezvenyek" replace state={{belepes: belepes}} />;
    }
    return elem;
  }

  const oldalProps = {
    onKilepes: onClick_kilepes,
    callAPI: callAPI,
    getCommInProgress: getCommInProgress,
    felhasznalo: felhasznalo,
    setFelhasznalo: setFelhasznalo,
    frissitFelhasznalo: frissitFelhasznalo,
    onSetNev: onSetNev
  };

  if (!konfigKesz){
    return (<div />)
  }else{
    return (
      <div className="App">

        {apiErrorMessage !== undefined ?
          <div className="apiErrorMessageBox">
            <div className="apiErrorMessage" dangerouslySetInnerHTML={{__html: apiErrorMessage}} />
            <Button onClick={onClick_errorMessage}>Close</Button>
          </div>
          : undefined
        }

          <Routes>
            <Route path="/" element={<Navigate to="/rendezvenyek" replace />} />
            <Route path="/rendezvenyek" element={
              <Rendezvenyek
                {...oldalProps}
                onGoogleCredential={onGoogleCredential}
              />}
            />
            <Route path="/rendezveny/:rendezvenyID/regisztracio" element={
              <RegisztracioOldal
                {...oldalProps}
                vedett={vedett}
              />}
            />
            <Route path="/megrendeles/:megrendelesID" element={
              <MegrendelesOldal
                {...oldalProps}
                vedett={vedett}
              />}
            />
            <Route path="/admin" element={
              <AdminOldal
                onKilepes={onClick_kilepes}
                felhasznalo={felhasznalo}
                callAPI={callAPI}
                getCommInProgress={getCommInProgress}
              />}
            />
            <Route path="*" element={<Navigate to="/rendezvenyek" replace />} />
          </Routes>

        </div>
    )
  }
}

export default App;
